import apiFetch from '../apiFetch'

export default function (documentId, sheetId, token) {
  return apiFetch({ endPoint: `document/${documentId}/sheet/${sheetId}/visor`, method: 'GET', body: null, token: token })
}
